export const adminTH ={
    //ตั้งค่ารับสมัคร
    applicationForm:'รับสมัครนักเรียน',
    applicationTitle:'ชื่อรอบการสมัคร',
    applicationAvailable:'เปิดรับ',
    curriculumAndclassroom:'แผนการเรียน และระดับชั้นที่รับสมัคร',
    lastEdited:'แก้ไขล่าสุด',
    setupApp:'ตั้งค่าการรับสมัคร',
    listApp:'รายชื่อผู้สมัคร',
    listQualified:'รายชื่อผู้ผ่านการคัดเลือก',
    searchBy:'ค้นหาโดย ปีการศึกษา ',
    searchByCurriculum:'ค้นหาโดย แผนการเรียน ',
    searchByStudent:'ค้นหาโดย ชื่อนักเรียน/เลขบัตร/ประเภท ',
    accademicYear:'ปีการศึกษา ',
    curriculum:'แผนการเรียน ',
    requiredAmount:'จำนวนที่เปิดรับ',
    candidateAmount:'จำนวนผู้สมัคร',
    applicationPeriod:'ช่วงเวลาการรับสมัคร',
    changePassword:'เปลี่ยนรหัสผ่าน',
    allStatus:'สถานะทั้งหมด',
    type:'ประเภท',
    otherSystem:'ระบบอื่นๆ',
    schoolbus:'รถรับ - ส่งนักเรียน',
    tuitionPayment:'ชำระค่าเทอม',
    createOnline:'กรุณาสร้างฟอร์มสมัครออนไลน์',
    logout:'ออกจากระบบ',
    search:'ค้นหา',
    applicationAvailableStart:'วันที่เปิดรับสมัคร',
    applicationDeadline:'วันที่ปิดรับสมัคร',
    applicationFee:'ค่าธรรมเนียมการสมัคร',
    completePayment:'ชำระเงินภายในวันที่',
    receivedFee:'ค่าธรรมเนียมที่ได้รับ',

    //รายชื่อผู้สมัคร
    notfound:'ไม่พบข้อมูลผู้สมัคร',
    guide:'คำแนะนำ',
    guide_content:'กดปุ่ม',
    guide_content1:'ที่รายชื่อผู้สมัคร เพื่อดูรายละเอียดใบสมัครหรือแก้ไขสถานะ',
    guide_content2:'คำอธิบายสถานะ',
    guide_content3:'ลงทะเบียน ผู้สมัครส่งใบสมัครสำเร็จ',
    guide_content4:'กรณีมีค่าธรรมเนียมการสมัครจะมีสถานะ ดังนี้',
    guide_content5:'รอการชำระเงิน ผู้สมัครส่งใบสมัครแต่ยังรอการชำระเงิน',
    guide_content6:`ชำระเงินสำเร็จ : ผู้สมัครส่งใบสมัครและชำระเงินสำเร็จ`,
    guide_content7:`มีสิทธิ์สอบ : ผู้สมัครผ่านเกณฑ์การสมัคร`,
    guide_content8:`ไม่มีสิทธิ์สอบ : ผู้สมัครไม่ผ่านเกณฑ์การสมัคร`,
    guide_content9:`รอการยืนยันสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ รอผู้สมัครยืนยันสิทธิ์การเข้าศึกษา`,
    guide_content10:`ยืนยันสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ และผู้สมัครยืนยันสิทธิ์การเข้าศึกษาสำเร็จ`,
    guide_content11:`สละสิทธิ์ : ผลการสอบคัดเลือกผ่านเกณฑ์ แต่ผู้สมัครสละสิทธิ์การเข้าศึกษา`,
    guide_content12:`มอบตัวสำเร็จ : ผู้สมัครเข้ามอบตัวและชำระค่าเทอมที่โรงเรียนสำเร็จ`,
    guide_content13:`ไม่ผ่านเกณฑ์ : ผลการสอบคัดเลือกไม่ผ่านเกณฑ์`,
    guide_content14:`รายชื่อที่มีสถานะมอบตัวสำเร็จเท่านั้น ที่จะสามารถนำเข้าฐานข้อมูลนักเรียนของ Schooney ได้`,
    guide_content15:`หลังจากคัดเลือกผู้สมัครสำเร็จ สามารถตรวจสอบรายชื่อผู้สมัครที่จะนำเข้าฐานข้อมูลนักเรียนได้ ที่เมนู`,
    guide_content16:`รายชื่อผู้ผ่านการคัดเลือก`,
    candidateList:'รายชื่อผู้สมัคร',
    listApp_content:`กรุณาตรวจสอบสถานะผู้สมัครแต่ละคนและเปลี่ยนสถานะแต่ละคนภายในระยะเวลาที่กำหนด`,
    listApp_content2:`กรณีมีค่าธรรมเนียมการสมัคร หากผู้สมัครชำระเงินสำเร็จแล้ว แต่ admin ไม่ได้เปลี่ยนสถานะภายในวันประกาศผลระบบจะถือว่าผู้สมัครคนนั้นจะมีสิทธิ์สอบทันทีและกรณีไม่ชำระเงิน ระบบจะถือว่าหมดสิทธิ์สอบทันที`,
    listApp_content3:`กรณีไม่มีการชำระเงิน admin ไม่ได้เปลี่ยนสถานะ ระบบจะถือว่าผู้สมัครคนนั้นมีสิทธิ์สอบทันที`,
    successfulInitiation:'มอบตัวสำเร็จ',
    notFoundStatus: 'ไม่พบสถานะ',
    IDnumber:'เลขประจำตัวประชาชน',
    fullName:'ชื่อ - นามสกุล',
    applicants:'ผลการคัดเลือก',
    note:'หมายเหตุ',
    waitingConfirmation:'รอการยืนยันสิทธิ์',
    successfulEdit: 'บันทึกข้อมูลสำเร็จ',
    successfulDeleteFile: 'ลบเอกสารสำเร็จ',
    firstRound:'ตัวจริง',
    reserveRound:'ตัวสำรอง',
    applicantsInformation :'ข้อมูลผู้สมัคร',
    applicationIDcard :'บัตรเข้าห้องสอบ',

    studentInfo:{
        applicationDetail:'ระดับชั้นที่ต้องการสมัคร',
        grade:'ระดับชั้น',
        curriculum:'แผนการเรียน',
        applicantsInfo:'ข้อมูลนักเรียน',
        idCardNo:'รหัสบัตรประชาชน',
        fullname:'ชื่อ - นามสกุล',
        ethnicity:'เชื้อชาติ',
        nationality:'สัญชาติ',
        religion:'ศาสนา',
        birthdate :'วันเกิด',
        mobileNo:'เบอร์โทรศัพท์',
        email:'อีเมล',
        gender:'เพศ',
        talent:'ความสามารถพิเศษ'
    },
    addressInfo:{
        address:'ที่อยู่',
        legalAddress:'ที่อยู่ตามทะเบียนบ้าน',
        presentAddress:'ที่อยู่ปัจจุบัน'
    },
    parentInfo:{
        parentHeader:'ข้อมูลผู้ปกครอง',
        father:'บิดา',
        mother:'มารดา',
        guardian:'ผู้ปกครอง',
    },
    healthInfo:{
        weight:'น้ำหนัก',
        height:'ส่วนสูง',
        bloodType:'หมู่เลือด',
        medicalCondition:'โรคประจำตัว',
        drugAllergy:'แพ้ยา',
        regularMedications:'ยาที่ทานประจำ',
        kg:'กก.',
        cm:'ซม.',
        remark:'หมายเหตุ'
    },
    status:{
        status:'สถานะ',
        allStatus:{
            qualified:'มีสิทธิ์สอบ'
        },
        answer:{
            qualified:'มีสิทธิ์สอบ',
            notQualified:'ไม่มีสิทธิ์สอบ'
        },
        step3:{
            header:'ขั้นตอนถัดไป',
            content1:'นำรายชื่อเข้าสู่ฐานข้อมูลนักเรียนระบบ Schooney',
            content2:'สามารถกำหนดห้องเรียนสำหรับผู้มีสิทธิ์เข้าศึกษา ที่เมนู',
            link:'รายชื่อผู้ผ่านการคัดเลือก',
        },
        resultQualified:'เลือกผลการคัดเลือกสิทธิ์การเข้าสอบ',
        statusContent:'*ระบบเปลี่ยนสถานะให้โดยอัตโนมัติ เนื่องจาก Admin ไม่ได้เปลี่ยนสถานะภายในเวลาที่กำหนด',
        dateAnnounce:'วันประกาศผลสอบ',
        time:'เวลา',
        fillResult:'ระบุผลคะแนนสอบ',
        passedHeader:'ผ่านเกณฑ์',
        passed:'ผ่าน',
        notPassed:'ไม่ผ่าน',
        fillType:'ระบุประเภท',
        fillNo:'ลำดับที่',
        score:'ผลรวมคะแนนสอบ',
        fillScore:'ระบุคะแนนสอบ',
        fillReservedNo: 'ระบุลำดับตัวสำรอง',
        scoreTooltip:{
            content1:'สำหรับระบุผลรวมคะแนนสอบเพื่อเป็นข้อมูลในการคัดเลือกผู้สมัคร',
            content2:'ผู้สมัครจะไม่เห็นข้อมูลนี้'
        },
        noTooltip:{
            content1:'สำหรับระบุลำดับตัวสำรองเพื่อเป็นข้อมูลในการคัดเลือกผู้สมัคร',
            content2:'ผู้สมัครจะไม่เห็นข้อมูลนี้'
        },
        confirmAndAnnounce:'ยืนยันและประกาศ',
        deadlineFirstRound:'วันสิ้นสุดการยืนยันสิทธิ์ (รอบตัวจริง)',
        deadlineReserveRound:'วันสิ้นสุดการยืนยันสิทธิ์ (รอบสำรอง)',
        initiationDay:'วันมอบตัว',
        initiationComplete:'มอบตัวสำเร็จ',
    },
    announcement:{
        announce:'ประกาศผล',
        result:'ผลการคัดเลือก',
        score:'ผลรวมคะแนนสอบ',
        points:'คะแนน',
        type:'ประเภท',
        no:'ลำดับที่',
        confirmationDate:'วันที่ยืนยันสิทธิ์'
    },
    payment:{
        paymentSlip:'หลักฐานการชำระเงิน',
        date:'วันที่ชำระ',
        time:'เวลา',
        amount:'จำนวนทั้งหมด',
        transactionID:'หมายเลขธุรกรรม',
        dragAndDrop:'ลาก & วางเพื่ออัปโหลดไฟล์ หรือ',
        fullDragAndDrop:'ลาก & วางเพื่ออัปโหลดไฟล์ หรือ อัปโหลด',
        upload:'อัปโหลด'
    },
    other:{
        otherHeader:'ข้อมูลอื่น ๆ',
        former:'สถานศึกษาเดิม',
        gpax:'เกรดเฉลี่ยสะสม (GPAX)',
        lastEducation:'ชั้นเรียนสุดท้าย',
    },
    document:{
        documentHeader:'เอกสารการสมัคร',
        downloadDocument:'ดาวน์โหลดทั้งหมด'
    },
    remark:{
        remarkHeader:'หมายเหตุ',
        save:'บันทึก',
        remarkText:'ระบุหมายเหตุเพิ่มเติมสำหรับแอดมินเท่านั้น ผู้สมัครจะไม่เห็นข้อความนี้'
    },
    stepper:{
        step1:'ยืนยันสิทธิ์สอบ',
        step2:'ระบุผลการคัดเลือก',
        step3:'มอบตัว'
    },
    modal:{
        passedModal:'คะแนนผ่านเกณฑ์',
        notPassedModal:'คะแนนไม่ผ่านเกณฑ์',
        initiationModal:'มอบตัวสำเร็จ',
        qualifiedModal:'ยืนยันสิทธิ์ในการเข้าสอบ',
        notQualifiedModal:'ไม่มีสิทธิ์ในการเข้าสอบ',
        removeModal:'ต้องการลบเอกสารการสมัคร',
        qualifiedModalContent:{
            head:'หลังจากยืนยันจะไม่สามารถแก้ไขสิทธิ์การเข้าสอบของ “',
            tail:'” ได้อีก'
        },
        notQualifiedModalContent:{
            head:'หลังจากยืนยันจะไม่สามารถแก้ไขสิทธิ์การเข้าสอบของ “',
            tail:'” ได้อีก'
        },
        passedModalContent:{
            head:'หลังจากกดยืนยัน จะไม่สามารถแก้ไขผลการสอบของ “',
            tail:'” ได้อีก'
        },
        initiationModalContent:{
            head:'หลังจากกดยืนยัน จะไม่สามารถแก้ไขข้อมูลส่วนตัวของ “',
            tail:'” ได้อีก'
        },
        removeModalContent:'ไฟล์จะถูกลบอย่างถาวร',
    },
    button:{
        confirm:'ยืนยัน',
        cancel:'ยกเลิก'
    },
    file:{
        overSize:'ขนาดไฟล์เกิน 10 MB',
        errorUpload:'กรุณาอัปโหลดไฟล์ PNG / JPG',
        expired:'ไฟล์หมดอายุ',
        createNew:'กรุณาตั้งชื่อไฟล์ใหม่',
        requirePDFFile: 'กรุณาอัปโหลดไฟล์ PDF',
        changeFileName: 'กรุณาอัปโหลดไฟล์ใหม่'
    },
    hintForEditText1: 'ขั้นตอนการลงทะเบียนผู้สมัครจะระบุเฉพาะข้อมูลบางส่วนเท่านั้น',
    hintForEditText2: 'หลังจากผู้สมัครสอบคัดเลือกและมีผลสอบผ่านเกณฑ์จะสามารถระบุข้อมูลทั้งหมดได้',
    saveSuccess: 'บันทึกข้อมูลสำเร็จ'
}

export const adminEN ={
    //ตั้งค่ารับสมัคร
    applicationForm:'Application form',
    applicationTitle:'Application title',
    applicationAvailable:'Application available',
    curriculumAndclassroom:'Curriculum and classroom',
    lastEdited:'Last edited',
    setupApp:'Set up application form',
    listApp:'List of applicants',
    listQualified:'List of qualified applicants',
    searchBy:'Search by Academic year ',
    searchByCurriculum:'Search by curriculum',
    searchByStudent:`Search by name/ID number/type`,
    accademicYear:'Accademic year ',
    curriculum:'Curriculum',
    requiredAmount:'Required amount',
    candidateAmount:'Applicants',
    applicationPeriod:'Application Period ',
    changePassword:'Change password',
    allStatus:'All status',
    type:'Type',
    otherSystem:'Other system',
    schoolbus:'Schoolbus system',
    tuitionPayment:'Tuition payment',
    createOnline:'Please create an online application form',
    logout:'Logout',
    search:'Search',
    applicationAvailableStart:'Application available',
    applicationDeadline:'Application deadline',
    applicationFee:'Application fee',
    completePayment:'Complete payment within',
    receivedFee:'Application fee',
    firstRound:'First round',
    reserveRound:'Reserve round',
    applicantsInformation :'Applicants Information ',
    applicationIDcard :'Application ID card',

    //รายชื่อผู้สมัคร
    notfound:'Information not found.',
    guide:'Guidance',
    guide_content:'Click on',
    guide_content1:'the list of candidate to view application details or edit',
    guide_content2:'Status description',
    guide_content3:'Register :  candidate has submitted the application ',
    guide_content4:'In case of the school have an application fee, the status will be as follows:',
    guide_content5:'Waiting for payment : The candidate has submitted an application but not complete the payment',
    guide_content6:`Successful Payment : Applicants submit application and complete payment.`,
    guide_content7:`Qualified to take the exam : Applicants pass the application criteria.`,
    guide_content8:`Not qualified to take the exam : Applicants do not pass the application criteria.`,
    guide_content9:`Waiting for confirmation: Applicants pass the exam. Waiting to confirm the rights.`,
    guide_content10:`Confirmed the rights : Applicants pass the exam and confirmed the rights.`,
    guide_content11:`Waiver the rights : Applicants pass the exam but waiver the rights`,
    guide_content12:`Successful initiation : Applicants completed initiation and payment.`,
    guide_content13:`Not pass the exam : Applicants do not pass the exam.`,
    guide_content14:`Only applicants with successful initiation status can submit form to schooney system`,
    guide_content15:`After successful selection, Admin can check list of qualified applicants for submit to schooney system in`,
    guide_content16:`รายชื่อผู้ผ่านการคัดเลือก`,
    candidateList:'Candidate list',
    listApp_content:`Please check each candidate's status and change the status within the period`,
    listApp_content2:`In case of the school have an application fee and the candidate completed the payment but admin not change the status in the period, the system will assume that the candidate will have the right to take the exam and in case of not complete will assume that the candidate will not have the right to take the exam`,
    listApp_content3:`In case of school not have an application fee and admin not change the status in the period, the system will assume that the candidate will have the right to take the exam `,
    successfulInitiation:'Initiation complete',
    notFoundStatus: 'Invalid status',
    IDnumber:'ID number',
    fullName:'Full name',
    applicants:'Applicants',
    note:'Note',
    waitingConfirmation:'Waiting for confirmation',
    successfulEdit: 'successful',
    successfulDeleteFile: 'successful',
    studentInfo:{
        applicationDetail:'Application Detail',
        grade:'Grade',
        curriculum:'Curriculum',
        applicantsInfo:'Applicants information',
        idCardNo:'ID card number',
        fullname:'Fullname',
        ethnicity:'Ethnicity',
        nationality:'Nationality',
        religion:'Religion',
        birthdate :'Birthdate ',
        mobileNo:'Mobile no.',
        email:'Email',
        gender:'Gender',
        talent:'Talent',
    },
    addressInfo:{
        address:'Address',
        legalAddress:'Legal address',
        presentAddress:'Present address'
    },
    parentInfo:{
        parentHeader:'Parent Information',
        father:'Father',
        mother:'Mother',
        guardian:'Parent',
    },
    other:{
        otherHeader:'Other information',
        former:'Former school',
        gpax:'GPAX',
        lastEducation:'Last education',
    },
    healthInfo:{
        weight:'Weight',
        height:'Height',
        bloodType:'Blood type',
        medicalCondition:'Medical condition',
        drugAllergy:'Drug allergy',
        regularMedications:'Regular medications',
        kg:'kg.',
        cm:'cm.',
        remark:'remark'
    },
    status:{
        status:'Status',
        allStatus:{
            qualified:'Qualified'
        },
        answer:{
            qualified:'Qualified',
            notQualified:'Not qualified'
        },
        step3:{
            header:'Next step',
            content1:`Transfer applicant's information to Schooney system`,
            content2:'Create classroom for applicants in',
            link:'List of qualified applicants',
        },
        resultQualified:'Select result of qualification ',
        statusContent:'*Changed by the system (Admin did not change status within the period)',
        dateAnnounce:'Date of announcement',
        time:'Time',
        fillResult:'Fill the result of examination',
        passedHeader:'Passed',
        passed:'Passed',
        notPassed:'Not passed',
        fillType:'Please fill type',
        fillNo:'No.',
        score:'score',
        fillScore:'Please fill score',
        fillReservedNo: 'Please fill the number of reserve number',
        scoreTooltip:{
            content1:'Fill the score result of the examination for note',
            content2:'Applicants will not allow to see this Information',
        },
        noTooltip:{
            content1:'Fill the number of reserve round for note',
            content2:'Applicants will not allow to see this Information'
        },
        confirmAndAnnounce:'Confirm and Announce',
        deadlineFirstRound:'Deadline of confirmation (first round)',
        deadlineReserveRound:'Deadline of confirmation (reserve round)',
        initiationDay:'The initiation day',
        initiationComplete:'Initiation complete',
    },
    payment:{
        paymentSlip:'Payment slip',
        date:'Date of payment ',
        time:'Time',
        amount:'Amount',
        transactionID:'Transaction ID',
        dragAndDrop:'Drag & drop to upload file or',
        fullDragAndDrop:'Drag & drop to upload file or Upload',
        upload:'Upload'
    },
    announcement:{
        announce:'Announcement',
        result:'Result',
        score:'Score',
        type:'Type',
        points:'Points',
        no:'No.',
        confirmationDate:'Confirmation date'
    },
    document:{
        documentHeader:'Document file ',
        downloadDocument:'Download all'
    },
    remark:{
        remarkHeader:'Remark',
        save:'Save',
        remarkText:'Note for admin only applicants will not see this note'
    },
    stepper:{
        step1:'Confirmation',
        step2:'Selection',
        step3:'Initiation'
    },
    modal:{
        passedModal:'Passed',
        notPassedModal:'Not passed',
        initiationModal:'Initiation complete',
        qualifiedModal:'Qualified',
        notQualifiedModal:'Not qualified',
        removeModal:'Remove Document file ',
        qualifiedModalContent:{
            head:'After confirmation will not allow to change the result of “',
            tail:'”'
        },
        notQualifiedModalContent:{
            head:'After confirmation will not allow to change the result of “',
            tail:'”'
        },
        passedModalContent:{
            head:'After confirmation will not allow to change the result of “',
            tail:'”'
        },
        initiationModalContent:{
            head:'After confirmation will not allow to change information of “',
            tail:'”'
        },
        removeModalContent:'File will be deleted permanently',
    },
    button:{
        confirm:'Confirm',
        cancel:'Cancel'
    },
    file:{
        overSize:'File size over than 10 MB',
        errorUpload:'Please upload file PNG/JPG',
        expired:'File expired',
        createNew:'Please create new name',
        requirePDFFile: 'Please upload PDF file',
        changeFileName: 'Please upload new file'
    },
    hintForEditText1: 'Registration process required only important information',
    hintForEditText2: 'After passed the exam, system will allow to fill other information',
    //รายชื่อผ๓้ผ่านการคัดเลือก
    saveSuccess: 'Succesful'
}
